import React from "react";
import TrefoilHomeScene from "./TrefoilHomeScene";

function AnimatedHero() {
  return (
    <div className="animated-hero-scene">
      <TrefoilHomeScene />
    </div>
  );
}

export default AnimatedHero;

